var exports = {
  "i": "wrapper__qKzwZR",
  "b": "logoWrapper___1jNny",
};

module.exports = exports;
